import React from "react";
import { useShallow } from "zustand/react/shallow";
import {
    RoomPlayer,
    RoomPlayerAction as RoomPlayerActionEnum
} from "@uno/protocol";
import { useTranslation } from "react-i18next";
import useAnimation from "hook/useAnimation";
import useStoreAnimation from "store/useStoreAnimation";
import { useSounds } from "context/SoundContext";

type RoomPlayerActionProps = {
    roomPlayer: RoomPlayer
};

type Action = {
    text: string;
    sound: "uno" | "block";
};

const RoomPlayerAction = (props: RoomPlayerActionProps) => {
    const { t } = useTranslation();
    const id = props.roomPlayer?.player.id as string;
    const ref = React.useRef<HTMLDivElement>(null);
    const animations = useStoreAnimation(useShallow(state => state.animations));
    const currentAnimation = animations[id]?.[0];
    const { play } = useSounds();

    useAnimation({ id, ref });

    const actions = React.useMemo<Partial<Record<RoomPlayerActionEnum, Action>>>(() => ({
        [RoomPlayerActionEnum.Uno]: {
            text: "LAST!",
            sound: "uno"
        },
        [RoomPlayerActionEnum.DrawTwo]: {
            text: ":content " + t("room.cards_label"),
            sound: "block"
        },
        [RoomPlayerActionEnum.DrawFour]: {
            text: ":content " + t("room.cards_label"),
            sound: "block"
        },
        [RoomPlayerActionEnum.Blocked]: {
            text: t("room.blocked"),
            sound: "block"
        },
    }), [t]);

    React.useEffect(() => {
        if(currentAnimation?.name) {
            const action = actions[currentAnimation.name as keyof typeof actions];

            if(action) {
                play(action.sound);
            }
        }
    }, [currentAnimation?.name]);

    const currentAction = currentAnimation?.name ? actions[currentAnimation.name as keyof typeof actions] ?? null : null;
    const payload = currentAnimation?.payload as { content?: string } | undefined;
    const content = payload?.content ?? null;

    return (
        <div ref={ref} className="absolute z-50">
            {currentAction && (
                <div className="w-fit bg-gradient-to-b from-pink-400 to-pink-600 flex items-center justify-center px-6 py-2.5 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(236,72,153,0.5)] border-2 border-pink-300/40">
                    <span className="font-changa-one text-lg text-white uppercase whitespace-nowrap drop-shadow-md">
                        {currentAction.text.replace(":content", content ?? "")}
                    </span>
                </div>
            )}
        </div>
    )
}

export default RoomPlayerAction;
